import { useQuery } from '@tanstack/react-query';
import { aiConstantsApi } from '../../AIConstantsApi';
import type { GetAIConstantsParams } from '../../types';
import { QueryKey } from '@shared/config';

export const useGetAIConstants = (params: GetAIConstantsParams) => {
  return useQuery({
    queryKey: [QueryKey.GET_AI_CONSTANTS, params],
    queryFn: () => aiConstantsApi.getAIConstants(params),
  });
};
